export const FilterForm = {
  showArrow: false,
  title: {
    type: "div",
    className: "d-flex",
    children: [
      {
        type: "icon",
        antIcon: "FilterOutlined",
        style: { marginRight: "6px", paddingTop: "4px" },
      },
      {
        type: "text",
        content: "{{FILTER_BY}}",
      },
    ],
  },
  children: [
    {
      type: "form",
      formRef: "filterForm",
      onFinish: "onSubmitFilterForm",
      children: [
        {
          type: "div",
          className: "w-100",
          children: [
            {
              type: "row",
              gutter: 8,
              children: [
                {
                  type: "col",
                  span: 4,
                  children: [
                    {
                      type: "input",
                      variant: "datepicker",
                      name: "month",
                      label: "{{MONTH}}",
                      actionKey: "ON_FILTER_CHANGE",
                      inputConfig: {
                        placeholder: "{{ALL}}",
                        size: "large",
                        picker: "month",
                        format: "YYYY-MM",
                        style: { width: "100%" },
                      },
                    },
                  ],
                },
                {
                  type: "col",
                  span: 3,
                  children: [
                    {
                      type: "select",
                      name: "transfer_type",
                      label: "{{TYPE}}",
                      actionKey: "ON_FILTER_CHANGE",
                      inputConfig: {
                        placeholder: "{{ALL}}",
                        size: "large",
                        allowClear: true,
                        options: [
                          { value: "reward",         label: "Reward" },
                          { value: "transfer",       label: "Transfer" },
                          { value: "tax_deduction",  label: "Tax Deduction" },
                        ],
                      },
                    },
                  ],
                },
                {
                  type: "col",
                  span: 3,
                  children: [
                    {
                      type: "select",
                      name: "is_ready",
                      label: "{{READY}}",
                      actionKey: "ON_FILTER_CHANGE",
                      inputConfig: {
                        placeholder: "{{ALL}}",
                        size: "large",
                        allowClear: true,
                        options: [
                          { value: true, label: "Ready" },
                          { value: false, label: "Not Ready" },
                        ],
                      },
                    },
                  ],
                },
                {
                  type: "col",
                  span: 3,
                  children: [
                    {
                      type: "select",
                      name: "is_back_order",
                      label: "{{BACK_ORDER}}",
                      actionKey: "ON_FILTER_CHANGE",
                      inputConfig: {
                        placeholder: "{{ALL}}",
                        size: "large",
                        allowClear: true,
                        options: [
                          { value: true, label: "Back Order" },
                          { value: false, label: "Regular" },
                        ],
                      },
                    },
                  ],
                },
                {
                  type: "col",
                  span: 3,
                  children: [
                    {
                      type: "select",
                      name: "status",
                      label: "{{STATUS}}",
                      actionKey: "ON_FILTER_CHANGE",
                      inputConfig: {
                        placeholder: "{{ALL}}",
                        size: "large",
                        allowClear: true,
                        options: [
                          { value: "PENDING", label: "Pending" },
                          { value: "PROCESSING", label: "Processing" },
                          { value: "COMPLETED", label: "Completed" },
                          { value: "FAILED", label: "Failed" },
                        ],
                      },
                    },
                  ],
                },
                {
                  type: "col",
                  span: 8,
                  children: [
                    {
                      type: "select",
                      name: "program_id",
                      label: "{{BONUS_TYPE}}",
                      actionKey: "ON_FILTER_CHANGE",
                      inputConfig: {
                        dataKey: "filterProgramOptions",
                        placeholder: "{{ALL}}",
                        size: "large",
                        allowClear: true,
                      },
                    },
                  ],
                },
              ],
            },
            {
              type: "div",
              className: "d-flex justify-content-end",
              children: [
                {
                  type: "button",
                  buttonType: "text",
                  className: "mr-2 my-1",
                  actionKey: "RESET_FILTER",
                  children: [{ type: "text", content: "{{CLEAR}}" }],
                },
                {
                  type: "button",
                  htmlType: "submit",
                  buttonType: "primary",
                  className: "my-1",
                  children: [{ type: "text", content: "{{REFRESH}}" }],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
